import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getMerchants = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  if (req.status && req.status != "ALL") queryParams.set("status", req.status);
  return await customFetch(
    `v1/merchant?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getMerchant = async (id: string) => {
  return await customFetch(`v1/merchant/${id}`, {
    method: "GET",
  });
};
export const createMerchant = async (data: any) => {
  return await customFetch("v1/merchant", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateMerchant = async (id: string, data: any) => {
  return await customFetch(`v1/merchant/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteMerchant = async (id: string) => {
  return await customFetch(`v1/merchant/${id}`, {
    method: "DELETE",
  });
};


export const countPendingMerchants = async () => {
  return await customFetch(`v1/merchant/count-pending`, {
    method: "GET",
  });
};


